import { hasElements } from "utils/arrays";

export const getEvidenceDocs = (evidence) => {
    if (evidence && hasElements(evidence.docs)) {
        return evidence.docs.filter((doc) => doc.origin !== "analysis");
    }
    return [];
};

export const getAnalysisDocs = (evidence) => {
    if (evidence && hasElements(evidence.docs)) {
        return evidence.docs.filter((doc) => doc.origin === "analysis");
    }
    return [];
};
